import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";

export const MailContent = ({ open, handleClose, content }) => {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        Содржина на меил порака
        <span style={{ float: "right" }}>
          <IconButton onClick={handleClose}>✕</IconButton>
        </span>
      </DialogTitle>
      <DialogContent dividers>
        <div
          dangerouslySetInnerHTML={{ __html: content }}
          style={{ minWidth: "500px", minHeight: "400px" }}
        />
      </DialogContent>
    </Dialog>
  );
};
